import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  DataFileTypeModel,
  getDataFileTypeLabel,
  vehicleFileAPI,
} from "../api/vehicleFileAPI";
import { Problem, ValidationProblem } from "../api/backendApi";
import MultiFileUpload from "../common/MultiFileUpload";
import ErrorDisplay from "../common/ErrorDisplay";

interface DataFileUploadProps {
  number: string;
  type: DataFileTypeModel;
  filename: string | null;
  title: string;
  onOk: () => void;
  onCancel: () => void;
}

function DataFileUpload({
  number,
  type,
  filename,
  title,
  onOk,
  onCancel,
}: DataFileUploadProps) {
  const [show, setShow] = useState(true);
  const [error, setError] = useState<Problem | string | undefined>(undefined);
  const [allowClose, setAllowClose] = useState(true);

  const handleClose = () => {
    if (allowClose) {
      setShow(false);
      onCancel();
    }
  };

  const accept =
    type === DataFileTypeModel.AutoCADFile
      ? ".dwg"
      : type === DataFileTypeModel.CrsFile
        ? ".mpfz"
        : type === DataFileTypeModel.PDFFile
          ? ".pdf"
          : "";

  const fullPath = title?.length > 0 ? title + "/" : "";

  const uploadFile = async (name: string, file: File): Promise<boolean> => {
    let result = await vehicleFileAPI.uploadDataFile(number, type, name, file);
    if (result.ok) return true;
    else {
      if (result.problem.type === "crsbuilder/validation") {
        const validationProblem = result.problem as ValidationProblem;

        setError(
          Object.keys(validationProblem.validation)
            .map((k) => validationProblem.validation[k])
            .join("\n"),
        );
      } else setError(result.problem);

      return false;
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Upload file - {filename ? filename : getDataFileTypeLabel(type)}
          {!filename && title?.length > 0 && (
            <div style={{ fontSize: "35%" }}>{title}</div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ErrorDisplay error={error} />
        <MultiFileUpload
          directories={
            !filename &&
            (type === DataFileTypeModel.SelectedFileCrsPic ||
              type === DataFileTypeModel.SelectedFileCheckInfo ||
              type === DataFileTypeModel.SourceFileOrgPic ||
              type === DataFileTypeModel.SourceFileTechInfoEU ||
              type === DataFileTypeModel.SourceFileTechInfoUSA ||
              type === DataFileTypeModel.SourceFileTechInfoPacific ||
              type === DataFileTypeModel.SourceFileArchive)
          }
          multiple={
            !filename &&
            type !== DataFileTypeModel.CrsFile &&
            type !== DataFileTypeModel.AutoCADFile
          }
          dragAndDropEnabled={!filename}
          filter={accept}
          onCancel={() => {
            setAllowClose(true);
            onCancel();
          }}
          onFinished={() => {
            setAllowClose(true);
            onOk();
          }}
          onStarted={() => setAllowClose(false)}
          onUploadFile={(name, file) =>
            uploadFile(fullPath + (filename ?? name), file)
          }
        />
      </Modal.Body>
    </Modal>
  );
}

export default DataFileUpload;
